import service from './service'
import Qs from 'qs'


const PRODUCT_ID = 2
export function getContent(id) {
    return service.post('/web/getContent', Qs.stringify({ id }))
}

export function getProductPrice(versionId, lang, productId = PRODUCT_ID) {
    return service.post('/web/getProductPrice', Qs.stringify({ productId, versionId, lang }))
}
// export function getProductPrice() {
//     return service.post('/web/getProductPrice')
// }
export function getProductPriceList(lang, productId = PRODUCT_ID) {
    return service.post('/web/getProductPriceList', Qs.stringify({ productId, lang }))
}

export function getChannelById(body) {
    return service.post('/product/web/getChannelById', body)
}

export function searchContent(channelCode = '', lang, pageNo, pageSize, productId = PRODUCT_ID) {
    return service.post('/web/searchContent', Qs.stringify({ productId, channelCode, lang, pageNo, pageSize }))
}

export function searchArticle(channelCode, lang, keywords, pageNo, pageSize, productId = PRODUCT_ID) {
    return service.post('/web/searchArticle', Qs.stringify({ productId, channelCode, lang, channelCode, keywords, pageNo, pageSize }))
}

export function searchReviewList(lang, pageNo, pageSize, productId = PRODUCT_ID) {
    return service.post('/web/searchReviewList', Qs.stringify({ productId, lang, pageNo, pageSize }))
}


export function addMessage(title, lang, name, company, phone, email, industry, content, members, productId = PRODUCT_ID) {
    return service.post('/web/addMessage', Qs.stringify({ title, lang, name, company, phone, email, industry, content, members, productId }))

}


export function addMessageUs(lang, name, company, phone, email, title, content, productId = PRODUCT_ID) {
    return service.post('/web/addMessage', Qs.stringify({ lang, name, company, phone, email, title, content, productId }))

}
export function addReview(lang, name, country, phone, email, score, title, content, productId = PRODUCT_ID) {
    return service.post('/web/addReview', Qs.stringify({ lang, name, country, phone, email, score, title, content, productId }))
}
export function getSEO(pageCode, productId = PRODUCT_ID) {
    return service.post('/web/searchSEO', Qs.stringify({ productId, pageCode }))
}

export function addTrial(email, productId = PRODUCT_ID) {
    return service.post('/web/addTrial', Qs.stringify({ email, productId }))
}

export function downInstallPackage(versionId, lang, bit, productId = PRODUCT_ID) {
    return service.post('/web/downInstallPackage', Qs.stringify({ versionId, lang, bit, productId }))
}


// WEBPACK FOOTER //
// ./src/utils/http/loadData.js